import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { boardState, BoardStatus, setStatus } from 'common/modules/app/board';
import { GlossaryState } from 'common/modules/app/glossaries';
import { Principal } from 'common/modules/app/principal';
import { Glossary } from 'common/utils/glossary';
import {
  SasPagePath,
  sasStaticUrl,
  getPlanListUrl,
  getPurchaseUrl
} from 'common/utils/urls';
import { AppState } from 'pages';
import { MenuBoard } from '../components/MenuBoard';
import { getLogin } from 'common/modules/domain/user';
import { sasApiUrl } from 'common/utils/urls';

// StoreのStateからComponentに渡すPropsへ
const useStateProps = () => {
  const boardState = useSelector<AppState, boardState>(
    (state) => state.app.board
  );
  const glState = useSelector<AppState, GlossaryState>(
    (state) => state.app.glossaries
  );
  const principalState = useSelector<AppState, Principal>(
    (state) => state.app.principal
  );
  return {
    isDisplay: boardState.status === BoardStatus.MENU_DISP,
    isLoggedIn: principalState.isLoggedIn,
    glossary: Glossary.instance(glState)
  };
};

type SelectedState = ReturnType<typeof useStateProps>;
// Actionをdispatchする関数からComponentに渡すPropsへ
const useDispatchProps = (state: SelectedState) => {
  const dispatch = useDispatch();

  /** プラン一覧の押下処理 */
  const onClickPlanList = () => {
    dispatch(setStatus(BoardStatus.NOT_DISP));
    // プラン情報一覧画面を再描画する
    window.location.href = getPlanListUrl();
  };

  /** 契約中プランの押下処理 */
  const onClickContractedList = () => {
    dispatch(setStatus(BoardStatus.NOT_DISP));
    // 未ログインの場合はログイン処理を行う
    if (!state.isLoggedIn) {
      dispatch(getLogin(`${sasApiUrl}${getPurchaseUrl()}`));
    } else {
      // 契約中プラン一覧画面を再描画する
      window.location.href = getPurchaseUrl();
      // window.location.href = SasPagePath.Purchase;
    }
  };

  /** 購入履歴の押下処理 */
  const onClickPurchaseHistory = () => {
    dispatch(setStatus(BoardStatus.NOT_DISP));
    // 未ログインの場合はログイン処理を行う
    if (!state.isLoggedIn) {
      dispatch(
        getLogin(`${sasApiUrl}${SasPagePath.Purchase}?purchase=history`)
      );
    } else {
      // 購入履歴画面を再描画する
      window.location.href = `${SasPagePath.Purchase}?purchase=history`;
    }
  };

  /** Newsの押下処理 */
  const onClickNews = () => {
    // Newsを別タブで開く
    window.open(`${sasStaticUrl}/st/news.html`);
    dispatch(setStatus(BoardStatus.NOT_DISP));
  };

  /** 利用ガイドの押下処理 */
  const onClickGuide = () => {
    // 利用ガイドを別タブで開く
    window.open(`${sasStaticUrl}/st/guide.html`);
    dispatch(setStatus(BoardStatus.NOT_DISP));
  };

  /** FAQの押下処理 */
  const onClickFaq = () => {
    // FAQを別タブで開く
    window.open(`${sasStaticUrl}/st/faq.html`);
    dispatch(setStatus(BoardStatus.NOT_DISP));
  };

  /** お問い合わせの押下処理 */
  const onClickContact = () => {
    // お問い合わせを別タブで開く
    window.open(`${sasStaticUrl}/st/contacts.html`);
    dispatch(setStatus(BoardStatus.NOT_DISP));
  };

  /** 利用規約の押下処理 */
  const onClickTermsOfService = () => {
    // 利用規約を別タブで開く
    window.open(`${sasStaticUrl}/st/term-of-use.html`);
    dispatch(setStatus(BoardStatus.NOT_DISP));
  };

  /** プライバシーポリシーの押下処理 */
  const onClickPrivacyPolicy = () => {
    // プライバシーポリシーを別タブで開く
    window.open('https://myid.canon/canonid/#/policy');
    dispatch(setStatus(BoardStatus.NOT_DISP));
  };

  /** クッキーポリシーの押下処理 */
  const onClickCookiePolicy = () => {
    // クッキーポリシーを別タブで開く
    window.open(`${sasStaticUrl}/st/cookie-policy.html`);
    dispatch(setStatus(BoardStatus.NOT_DISP));
  };

  /** サードパーティ製ソフトウェアについての押下処理 */
  const onClickSoftware = () => {
    // サードパーティ製ソフトウェアについてを別タブで開く
    window.open(`${sasStaticUrl}/st/3rdpartylicenses.txt`);
    dispatch(setStatus(BoardStatus.NOT_DISP));
  };

  return {
    isDisplay: state.isDisplay,
    isLoggedIn: state.isLoggedIn,
    glossary: state.glossary,
    onClickPlanList: onClickPlanList,
    onClickContractedList: onClickContractedList,
    onClickPurchaseHistory: onClickPurchaseHistory,
    onClickNews: onClickNews,
    onClickGuide: onClickGuide,
    onClickFaq: onClickFaq,
    onClickContact: onClickContact,
    onClickTermsOfService: onClickTermsOfService,
    onClickPrivacyPolicy: onClickPrivacyPolicy,
    onClickCookiePolicy: onClickCookiePolicy,
    onClickSoftware: onClickSoftware
  };
};

/**
 * プルダウンメニューのContainer Component
 */
export default function ContainerComponent() {
  const _props = { ...useDispatchProps(useStateProps()) };
  return <MenuBoard {..._props} />;
}
